export const ENTRY_TYPE = {
  RECEITA: 'receita',
  DESPESA: 'despesa',
};

export const ENTRY_TYPE_TO_ACCOUNT_PLAN_TYPES = {
  [ENTRY_TYPE.RECEITA]: ['receita'],
  [ENTRY_TYPE.DESPESA]: ['deducao', 'custo', 'despesa'],
};

export const accountPlanTypeToEntryType = (planType) =>
  planType === 'receita' ? ENTRY_TYPE.RECEITA : ENTRY_TYPE.DESPESA;

export const isAccountPlanCompatible = (planType, entryType) =>
  (ENTRY_TYPE_TO_ACCOUNT_PLAN_TYPES[entryType] || []).includes(planType);

// Mapa categoria da OS → código do plano de contas (receita). Usado na cobrança
// da OS para classificar automaticamente cada categoria no respectivo plano
// (RN01/RN02). 'thirdparty' (1.4) fica reservado — não há origem na OS hoje.
export const OS_CATEGORY_ACCOUNT_CODES = {
  bodyshop: '1.1', // Serviços de Funilaria e Pintura (array `service`)
  aesthetics: '1.2', // Serviços de Estética Automotiva (array `ae_service`)
  parts: '1.3', // Peças (array `parts`)
  thirdparty: '1.4', // Serviços de Terceiros — reservado, sem origem na OS hoje
};

// Rótulos exibidos na tabela de rateio da cobrança (RN06).
export const OS_CATEGORY_LABELS = {
  bodyshop: 'Funilaria e Pintura',
  aesthetics: 'Estética Automotiva',
  parts: 'Peças',
  thirdparty: 'Serviços de Terceiros',
};

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'corrente', label: 'Conta Corrente' },
  { value: 'poupanca', label: 'Conta Poupança' },
  { value: 'pagamento', label: 'Conta Pagamento' },
  { value: 'caixa', label: 'Caixa Físico' },
  { value: 'digital', label: 'Conta Digital' },
];

export const STATUS = {
  ATIVO: 'ativo',
  INATIVO: 'inativo',
};

export const ACCOUNT_STATUS = {
  ATIVA: 'ativa',
  INATIVA: 'inativa',
};

export const STATUS_OPTIONS = [
  { value: STATUS.ATIVO, label: 'Ativo' },
  { value: STATUS.INATIVO, label: 'Inativo' },
];

export const ACCOUNT_STATUS_OPTIONS = [
  { value: ACCOUNT_STATUS.ATIVA, label: 'Ativa' },
  { value: ACCOUNT_STATUS.INATIVA, label: 'Inativa' },
];

export const COST_CENTER_TYPE_OPTIONS = [
  { value: 'produtivo', label: 'Produtivo' },
  { value: 'comercial', label: 'Comercial' },
  { value: 'administrativo', label: 'Administrativo' },
  { value: 'financeiro', label: 'Financeiro' },
];

export const COST_CENTER_TYPE_COLORS = {
  produtivo: { bg: 'rgba(232,140,42,0.1)', color: '#e88c2a', border: 'rgba(232,140,42,0.3)' },
  comercial: { bg: 'rgba(74,144,217,0.1)', color: '#60b4f6', border: 'rgba(74,144,217,0.3)' },
  administrativo: { bg: 'rgba(255,255,255,0.06)', color: '#a0a0a0', border: 'rgba(255,255,255,0.15)' },
  financeiro: { bg: 'rgba(91,196,36,0.1)', color: '#70E000', border: 'rgba(91,196,36,0.3)' },
};

export const ACCOUNT_PLAN_TYPE_OPTIONS = [
  { value: 'receita', label: 'Receita' },
  { value: 'deducao', label: 'Dedução' },
  { value: 'custo', label: 'Custo' },
  { value: 'despesa', label: 'Despesa' },
];

export const ACCOUNT_PLAN_TYPE_COLORS = {
  receita: { bg: 'rgba(91,196,36,0.12)', color: '#70E000', border: 'rgba(91,196,36,0.4)' },
  deducao: { bg: 'rgba(180,180,180,0.08)', color: '#a0a0a0', border: 'rgba(180,180,180,0.3)' },
  custo: { bg: 'rgba(74,144,217,0.12)', color: '#60b4f6', border: 'rgba(74,144,217,0.4)' },
  despesa: { bg: 'rgba(232,140,42,0.12)', color: '#e88c2a', border: 'rgba(232,140,42,0.4)' },
};

export const ACCOUNT_PLAN_NATURE = {
  receita: 'Crédito',
  deducao: 'Débito',
  custo: 'Débito',
  despesa: 'Débito',
};


export const PAYMENT_METHOD_OPTIONS = [
  { value: 'pix', label: 'Pix' },
  { value: 'boleto', label: 'Boleto' },
  { value: 'dinheiro', label: 'Dinheiro' },
  { value: 'cartao', label: 'Cartão' },
  { value: 'transferencia', label: 'Transferência' },
];

export const INSTALLMENT_STATUS = {
  PENDENTE: 'pendente',
  PAGO: 'pago',
  ATRASADO: 'atrasado',
};

export const INSTALLMENT_STATUS_COLORS = {
  pendente: { label: 'PENDENTE', bg: 'rgba(232,140,42,0.15)', color: '#e88c2a' },
  pago:     { label: 'PAGO',     bg: 'rgba(112,224,0,0.15)',  color: '#70E000' },
  atrasado: { label: 'ATRASADO', bg: 'rgba(241,96,99,0.15)',  color: '#f16063' },
};

// Cores dos gráficos (Recharts não lê tokens SCSS — manter em sincronia com
// FinancialDashboard/styles/_variables.scss: $fd-green/$fd-orange/$fd-blue).
export const CHART_COLORS = {
  green: '#70E000',
  orange: '#e88c2a',
  blue: '#60b4f6',
  grid: '#2e2e2e',
  axis: '#3a3a3a',
  tick: '#999',
  tooltipBg: '#1f1f1f',
};

export const INSTALLMENT_STATUS_FILTER_ALL = 'all';

export const INSTALLMENT_STATUS_FILTERS = [
  { key: INSTALLMENT_STATUS_FILTER_ALL, label: 'Todos' },
  { key: INSTALLMENT_STATUS.PENDENTE,   label: 'Pendente' },
  { key: INSTALLMENT_STATUS.ATRASADO,   label: 'Atrasado' },
  { key: INSTALLMENT_STATUS.PAGO,       label: 'Pago' },
];

// Centro de Custo oculto até futura implementação (o modal segue no código).
export const CADASTRO_ITEMS = [
  { key: 'banco', label: 'Banco' },
  { key: 'plano-contas', label: 'Plano de Contas' },
];

export const PERIOD_FILTERS = [
  { key: 'todos', label: 'Todos' },
  { key: 'hoje', label: 'Hoje' },
  { key: 'semana', label: 'Esta Semana' },
  { key: 'mes', label: 'Este Mês' },
  { key: 'proximos2meses', label: 'Próximos 2 meses' },
  { key: 'periodo', label: 'Selecionar Período' },
];

export const DRE_PERIOD_OPTIONS = [
  { key: 'mes',    label: 'Este Mês',           months: 1 },
  { key: 'ultmes', label: 'Último Mês',         months: 1, offset: 1 },
  { key: 'tri',    label: 'Últimos 3 Meses',    months: 3 },
  { key: 'sem',    label: 'Últimos 6 Meses',    months: 6 },
  { key: 'ano',    label: 'Últimos 12 Meses',   months: 12 },
  { key: 'custom', label: 'Selecionar Período', months: 0 },
];

export const DRE_SECTIONS = [
  { key: 'receita',          label: 'RECEITA BRUTA',                type: 'group' },
  { key: 'deducao',          label: '(-) DEDUÇÕES DA RECEITA',      type: 'group' },
  { key: '_receita_liquida', label: '= RECEITA LÍQUIDA',            type: 'subtotal' },
  { key: 'custo',            label: '(-) CUSTOS DAS VENDAS',        type: 'group' },
  { key: '_lucro_bruto',     label: '= LUCRO BRUTO',                type: 'subtotal' },
  { key: 'despesa',          label: '(-) DESPESAS OPERACIONAIS',    type: 'group' },
  { key: '_resultado',       label: '= LUCRO LÍQUIDO',              type: 'result' },
];

export const PROJECTED_HORIZONS = [
  { days: 15, label: '15 dias' },
  { days: 30, label: '30 dias' },
  { days: 60, label: '60 dias' },
  { days: 90, label: '90 dias' },
];

